import React, { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';

const DropboxCallback = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    // Obtener el código de la URL
    const urlParams = new URLSearchParams(window.location.search);
    const authCode = urlParams.get('code');
    const errorParam = urlParams.get('error');
    
    if (authCode) {
      setCode(authCode);
    } else if (errorParam) {
      setError(errorParam);
    }
  }, []);

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      p: 3
    }}>
      <Typography variant="h4" gutterBottom>
        Autorización de Dropbox
      </Typography>
      
      {code && (
        <Alert severity="success" sx={{ mb: 2, maxWidth: 600 }}>
          <Typography variant="h6" gutterBottom>
            ¡Autorización exitosa!
          </Typography>
          <Typography variant="body1" gutterBottom>
            Código de autorización obtenido. Copia este código y úsalo en el módulo de configuración:
          </Typography>
          <Box sx={{
            backgroundColor: '#f5f5f5',
            p: 2,
            borderRadius: 1,
            fontFamily: 'monospace',
            fontSize: '1.1rem',
            wordBreak: 'break-all',
            mt: 1
          }}>
            {code}
          </Box>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Puedes cerrar esta ventana y regresar al módulo de configuración de CONEM.
          </Typography>
        </Alert>
      )}
      
      {error && (
        <Alert severity="error" sx={{ mb: 2, maxWidth: 600 }}>
          <Typography variant="h6" gutterBottom>
            Error en la autorización
          </Typography>
          <Typography variant="body1">
            Ocurrió un error: {error}
          </Typography>
        </Alert>
      )}
      
      {!code && !error && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <CircularProgress />
          <Typography>Procesando autorización...</Typography>
        </Box>
      )}
    </Box>
  );
};

export default DropboxCallback;
